import React from 'react'
import {Route, IndexRoute} from 'react-router'
import Layout from './Layout'
import Password from './Password'
import FirmasDigitales from './FirmasDigitales'
import Security from './Security'
import State from './State'
import AvailablePacks from './Payments/AvailablePacks'
import PackPayments from './Payments/PackPayment'
import Profile from './Profile'

export default (
  <Route path="/settings" component={Layout}>
    <IndexRoute component={Profile} />
    <Route path="state" component={State} />
    <Route path="firmasDigitales" component={FirmasDigitales} />
    <Route path="password" component={Password} />
    <Route path="security" component={Security} />
    <Route path="state" component={State} />
    <Route path="payments/availablePacks" component={AvailablePacks} />
    <Route path="payments/payPack/:packId" component={PackPayments} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/index.js